import ReactDOM from 'react-dom';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import loadTranslations from 'js/localeSetup';

import './styles/popUp.scss';
import '../../css/modules/teamsport/teamsport.less';

import './styles/specialMessage.scss';
import './styles/teamsport.scss';

import store from './stores/store';
import Main from './main';

const routes = ['/teamsport/', '/sizes', '/customisation'];

function App(props) {
  return (
    <Router>
      <Main routes={props.routes} />
    </Router>
  );
}

(async () => {
  const rootElement = document.getElementById('teamsport');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(
      <Provider store={store}>
        <App routes={routes} />
      </Provider>,
      rootElement
    );
  }
})();
